import { MenuProps as BaseMenuProps } from 'components/Menu/Types'
import { FC } from 'react'
import { TextStyleSubmenu } from 'common/Prose/Toolbar/TextStylesMenu/TextStyleSubMenu'
import { FontFamilySubMenu } from 'common/Prose/Toolbar/TextStylesMenu/FontFamilySubMenu'
import { FontWeightSubMenu } from 'common/Prose/Toolbar/TextStylesMenu/FontWeightSubMenu'
import { FontSizeSubMenu } from 'common/Prose/Toolbar/TextStylesMenu/FontSizeSubMenu'
import { AlignmentSubMenu } from 'common/Prose/Toolbar/TextStylesMenu/AlignmentSubMenu'
import { TextColorPickerSubMenu } from 'common/Prose/Toolbar/TextStylesMenu/TextColorPickerSubMenu'
import { HighlightColorPickerSubMenu } from 'common/Prose/Toolbar/TextStylesMenu/HighlightColorPickerSubMenu'
import { CalloutSubMenu } from 'common/Prose/Toolbar/TextStylesMenu/CalloutSubMenu'
import { QuoteSubMenu } from 'common/Prose/Toolbar/TextStylesMenu/QuoteSubMenu'
import { TextStylesMenu } from 'common/Prose/Toolbar/TextStylesMenu/TextStylesMenu'

type MenuProps = Pick<BaseMenuProps<any>, 'menuType' | 'onAction'>

export const SubMenuMap: { [key: string]: FC<MenuProps> } = {
  textStyle: TextStyleSubmenu,
  fontFamily: FontFamilySubMenu,
  fontWeight: FontWeightSubMenu,
  fontSize: FontSizeSubMenu,
  alignment: AlignmentSubMenu,
  textColor: TextColorPickerSubMenu,
  textHighlight: HighlightColorPickerSubMenu,
  callout: CalloutSubMenu,
  quote: QuoteSubMenu,
}

export const TextStylesSubMenu = ({ menu, ...props }: { menu: string } & MenuProps) => {
  const Component = SubMenuMap[menu] || TextStylesMenu

  return <Component {...props} />
}
